module.exports = __webpack_public_path__ + "static/media/navidad4.d9137b75.webp";